import { InjectionToken, Provider } from '@angular/core';

import { Observable } from 'rxjs';

import { LocaleService } from '../services/locale.service';

export const SELECTED_LANG = new InjectionToken<Observable<string>>('SELECTED_LANG');

export const selectedLangProvider: Provider = {
  provide: SELECTED_LANG,
  useFactory: (localeService: LocaleService) => {
    return localeService.locale$;
  },
  deps: [LocaleService],
};
